<template>
   <div class="middle-box py-8 trial_page">
      <div class="container container-1200">
         <div class="row no-gutters row justify-content-center">
            <div class="col-3 pb-3 pt-3 text-center header-text">
               <div class="data-container text-center">
                  <a href="/" itemprop="url">
                     <img
                        itemprop="logo"
                        src="/public/images/fusioncharts-idera-logo.svg?0d0c856d035593d5f2e9f8ee80f2a23d"
                        alt="FusionCharts"
                        class="logo__fc"
                  /></a>
               </div>
            </div>
         </div>
         <div class="row text-center justify-content-center">
            <div class="col-6 pb-6 text-center header-text">
               <div class="text-center">
                  <div data-v-e5c0cd66="" class="icon-container">
                     <i
                        data-v-e5c0cd66=""
                        class="fc_done"
                        style="color: #62be93;font-size: 5rem;"
                     ></i>
                  </div>
                  <h2>Thank You!</h2>
                  <p>
                     We have received your request to be a part of our beta. You should receive an
                     email shortly—please follow the instructions in the email to get access to
                     FusionGrid. Please
                     <a
                        style="color: #2cc7c0;text-decoration: underline; cursor: pointer;"
                        @click="modalShowContactSales = !modalShowContactSales"
                     >
                        contact us
                     </a>
                     if you have any questions.
                  </p>
                  <p>
                     In the meantime...
                     <br />
                     <a href="https://www.fusioncharts.com/blog/"> Read Our Blog </a> <br />
                     <a
                        href="https://www.fusioncharts.com/download/fusioncharts-suite-xt?framework=csharp"
                     >
                        Start a Free Trial
                     </a>
                     <br />
                     <a href="https://www.fusioncharts.com/fusioncharts"> See Our Products </a>
                     <br />
                  </p>
               </div>
            </div>
         </div>
      </div>
      <b-modal v-model="modalShowContactSales" centered hide-footer>
         <ContactSales :purpose-options="purpose_options" />
      </b-modal>
   </div>
</template>
<script>
import ContactSales from '../components/elforms/Sales';

export default {
   name: 'Gridthankyou',
   components: {
      ContactSales,
   },
   data() {
      return {
         showMenu: false,
         modalShowContactSales: false,
         purpose_options: [
            {
               value: 'Licensing query for a SaaS application',
               text: 'Licensing query for a SaaS application',
            },
            {
               value: 'Licensing query for an on-premise application (OEM)',
               text: 'Licensing query for an on-premise application (OEM)',
            },
            {
               text: 'Licensing query for an enterprise plan',
               value: 'Licensing query for an enterprise plan',
            },
            {
               text: 'Reseller enquiry',
               value: 'Reseller enquiry',
            },
            {
               value: 'Licensing FusionExport',
               text: 'Licensing FusionExport',
            },
            { value: 'Payment through PO/Wire/Check', text: 'Payment through PO/Wire/Check' },
            { value: '​Product/Technical related query', text: '​Product/Technical related query' },
            { value: 'Other', text: 'Other' },
         ],
      };
   },
};
</script>
<style lang="scss">
.logo__fc {
   width: 100%;
}
</style>
